import { useEffect, useState } from "react";

/*
 * `defaultValue` is what the server HTML and the first client render use, before `matchMedia`
 * can be read.
 */
export const useIsMobile = (fold = 768, defaultValue = false): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(defaultValue);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const mediaQuery = window.matchMedia(`(max-width: ${fold - 1}px)`);

      const handleMatch = (e: MediaQueryListEvent) => {
        setIsMobile(e.matches);
      };

      setIsMobile(mediaQuery.matches);

      mediaQuery.addEventListener("change", handleMatch);

      return () => {
        mediaQuery.removeEventListener("change", handleMatch);
      };
    }
  }, [fold]);

  return isMobile;
};
